export default {
  data() {
    return {
      titleMap: {
        1: {
          icon: require('~/assets/img/icon-chart@2x.png'),
          title: '塾経営',
          metaTitle: '塾経営 記事一覧',
          path: '/topic/1',
        },
        2: {
          icon: require('~/assets/img/icon-computer@2x.png'),
          title: '経営/運営業務',
          metaTitle: '経営/運営業務  記事一覧',
          path: '/topic/2',
        },
        3: {
          icon: require('~/assets/img/icon-book@2x.png'),
          title: '教務',
          metaTitle: '教務 記事一覧',
          path: '/topic/3',
        },
        4: {
          icon: require('~/assets/img/icon-student@2x.png'),
          title: '採用/育成/組織',
          metaTitle: '採用/育成/組織 記事一覧',
          path: '/topic/4',
        },
        5: {
          icon: require('~/assets/img/icon-horn@2x.png'),
          title: '集客',
          metaTitle: '集客 記事一覧',
          path: '/topic/5',
        },
        6: {
          icon: require('~/assets/img/icon-parent@2x.png'),
          title: '保護者対応',
          metaTitle: '保護者対応 記事一覧',
          path: '/topic/6',
        },
        7: {
          icon: require('~/assets/img/icon-new@2x.png'),
          title: '新着記事',
          path: '/topic/7',
        },
        8: {
          icon: require('~/assets/img/icon-circle-flag@2x.png'),
          title: 'ランキング',
          path: '/topic/8',
        },
        9: {
          title: '連載',
          path: '/serial',
        },
        10: {
          title: 'Comiru活用法',
          path: '/topic/10',
        },
        tags: {
          title: 'タグページ',
          path: '/topic/tags',
        },
      },
    }
  },
}
